__turbopack_export_value__({
  "documents": "LegalDocumentsPage-module-scss-module__SpPYnG__documents",
  "documents__showMore": "LegalDocumentsPage-module-scss-module__SpPYnG__documents__showMore",
});
